import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { CanvasElementId } from '@blaze-runtime/engine-domain';
import { BulkActionType } from '@blaze-shared/workflow-domain';

import { generateBulkAction, removeBulkAction } from './bulk-actions.actions';

@Injectable()
export class BulkActionsFacade {
  private readonly store = inject(Store);

  createBulkAction(elementId: CanvasElementId, actionType: BulkActionType): void {
    this.store.dispatch(
      generateBulkAction({
        elementId,
        actionType,
        workflowIdPath: this.getWorkflowIdPath(actionType),
      }),
    );
  }

  createCustomBulkAction(elementId: CanvasElementId, path: string): void {
    this.store.dispatch(
      generateBulkAction({
        elementId,
        actionType: 'custom',
        workflowIdPath: this.getCustomActionWorkflowIdPath(path),
      }),
    );
  }

  removeBulkAction(elementId: CanvasElementId, actionType: BulkActionType): void {
    this.store.dispatch(
      removeBulkAction({
        elementId,
        actionType,
      }),
    );
  }

  private getWorkflowIdPath(actionType: BulkActionType): string {
    switch (actionType) {
      case 'delete':
        return 'content.bulkDelete.targetId';
      case 'export':
        return 'content.bulkExport.targetId';
      case 'edit':
        return 'content.bulkEdit.targetId';
    }

    throw new Error(`Unknown bulk action type: ${actionType}`);
  }

  private getCustomActionWorkflowIdPath(path: string): string {
    return `${path.split('.').slice(0, 3).join('.') /*content.bulkActions.index*/}.action.workflowId`;
  }
}
